export type PortalDataEnvironment = 'staging' | 'production';

/**
 * Backend data environment the current build reads by default. Mirrors the
 * default applied in services/api/client.ts: an explicit
 * VITE_BACKEND_DATA_ENVIRONMENT override wins, otherwise production builds use
 * production and everything else (staging/development/local) uses staging.
 * An explicit `override` (e.g. a `?environment=` query param) wins over both.
 */
export function getPortalDataEnvironment(override?: unknown): PortalDataEnvironment {
  if (override === 'production' || override === 'staging') return override;
  const envVar = import.meta.env.VITE_BACKEND_DATA_ENVIRONMENT;
  if (envVar === 'production' || envVar === 'staging') return envVar;
  return import.meta.env.VITE_ENVIRONMENT === 'production' ? 'production' : 'staging';
}
